"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonApiService = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var helper_1 = require("../../helper");
var Crypto_service_1 = require("../../../core/services/Crypto.service");
var Http_service_1 = require("../../../core/services/http/Http.service");
var Credential_service_1 = require("./Credential.service");
var JsonApiService = /** @class */ (function () {
    function JsonApiService(credentialService, cryptoService, httpService, seismicHelper) {
        this.credentialService = credentialService;
        this.cryptoService = cryptoService;
        this.httpService = httpService;
        this.seismicHelper = seismicHelper;
    }
    /**
     * @param serviceName
     * @param query
     * @param endpoint
     * @returns Example return value: https://tenant.seismic.com/JsonServiceApi/{serviceName}.svc?tenant={tenant}&signature={signature}&timestamp={timestamp}&user={user}
     */
    JsonApiService.prototype.getApiUrl = function (serviceName, endpoint, query) {
        return __awaiter(this, void 0, void 0, function () {
            var tenant, queryString, url, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        tenant = this.seismicHelper.getTenant();
                        serviceName = serviceName.endsWith('.svc') ? serviceName : serviceName + ".svc";
                        queryString = typeof query === 'object'
                            ? Object.entries(query)
                                .map(function (_a) {
                                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                                return k + "=" + v;
                            })
                                .join('&')
                            : query;
                        queryString = queryString ? "&" + queryString : '';
                        if (!(tenant === 'dev')) return [3 /*break*/, 2];
                        _a = "https://127.0.0.1:444/JsonServiceApi/" + serviceName;
                        return [4 /*yield*/, this.getParamsWithSignature(endpoint)];
                    case 1:
                        url = _a + (_c.sent()) + queryString;
                        return [2 /*return*/, url];
                    case 2:
                        _b = this.seismicHelper.getRootURL() + "/JsonServiceApi/" + serviceName;
                        return [4 /*yield*/, this.getParamsWithSignature(endpoint)];
                    case 3: return [2 /*return*/, _b + (_c.sent()) + queryString];
                }
            });
        });
    };
    /**
     * @deprecated
     * It's related to the old auth, it's going to be retired.
     * Please put Authentication into header to replace this.
     * We are going to change it to private firstly, and remove it eventually.
     *
     * @param endpoint
     * @param tenant
     * @param user
     * @param password
     * @returns Example return value: /{endpoint}?tenant={tenant}&user={user}&timestamp={timestamp}&signature={signature}
     */
    JsonApiService.prototype.getParamsWithSignature = function (endpoint, tenant, user, password) {
        return __awaiter(this, void 0, void 0, function () {
            var credential, now, timestamp, toSignStr, signature, result;
            return __generator(this, function (_a) {
                credential = this.credentialService.getSecurityCredentials();
                tenant = tenant || (credential === null || credential === void 0 ? void 0 : credential.Tenant) || '';
                user = user || (credential === null || credential === void 0 ? void 0 : credential.UserName) || '';
                password = password || (credential === null || credential === void 0 ? void 0 : credential.AccessKey) || '';
                now = new Date(new Date().getTime() + (window.SERVER_TIME_OFFSET || 0));
                timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds()).toString();
                toSignStr = '/' + endpoint + '?tenant=' + tenant + '&user=' + user + '&timestamp=' + timestamp;
                signature = this.cryptoService.base64HmacSHA1(toSignStr, password);
                result = '/' +
                    endpoint +
                    '?tenant=' +
                    encodeURIComponent(tenant) +
                    '&user=' +
                    encodeURIComponent(user) +
                    '&timestamp=' +
                    timestamp +
                    '&signature=' +
                    encodeURIComponent(signature);
                return [2 /*return*/, result];
            });
        });
    };
    /**
     * @deprecated
     * It's related to the old auth, it's going to be retired.
     * Please put Authentication into header to replace this.
     * We are going to change it to private firstly, and remove it eventually.
     */
    JsonApiService.prototype.getParamsWithSignatureAndClientType = function (serviceName, tenant, user, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParamsWithSignature(serviceName, tenant, user, password)];
                    case 1: return [2 /*return*/, ((_a.sent()) +
                            ("&SeismicClientName=" + this.seismicHelper.getClientType()))];
                }
            });
        });
    };
    JsonApiService.prototype.post = function (serviceName, endpoint, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiUrl(serviceName, endpoint, options === null || options === void 0 ? void 0 : options.query)];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, body, __assign({ isLibraryService: true }, options))];
                }
            });
        });
    };
    JsonApiService.prototype.put = function (serviceName, endpoint, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiUrl(serviceName, endpoint, options === null || options === void 0 ? void 0 : options.query)];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.put(url, body, __assign({ isLibraryService: true }, options))];
                }
            });
        });
    };
    JsonApiService.prototype.patch = function (serviceName, endpoint, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiUrl(serviceName, endpoint, options === null || options === void 0 ? void 0 : options.query)];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.patch(url, body, __assign({ isLibraryService: true }, options))];
                }
            });
        });
    };
    JsonApiService.prototype.delete = function (serviceName, endpoint, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiUrl(serviceName, endpoint, options === null || options === void 0 ? void 0 : options.query)];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.delete(url, __assign({ isLibraryService: true }, options))];
                }
            });
        });
    };
    JsonApiService.prototype.get = function (serviceName, endpoint, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiUrl(serviceName, endpoint, options === null || options === void 0 ? void 0 : options.query)];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.get(url, __assign({ isLibraryService: true }, options))];
                }
            });
        });
    };
    JsonApiService = __decorate([
        CommonService_decorator_1.CommonService('JsonApiService'),
        __metadata("design:paramtypes", [Credential_service_1.CredentialService,
            Crypto_service_1.CryptoService,
            Http_service_1.HttpService,
            helper_1.SeismicHelper])
    ], JsonApiService);
    return JsonApiService;
}());
exports.JsonApiService = JsonApiService;
//# sourceMappingURL=JsonApi.service.js.map